import { gql } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { timeColumns } from '../../utils/columns';
import { asCheck } from '../../utils/formatters';
import { useQueryWithMsg } from '../../utils/hooks';
import { searchBy } from '../../utils/search';
import { PaddedItemsTable } from '../tables/ItemsTable';

const AdminTeamTableQuery = gql`
  query AdminTeams {
    teams {
      id
      name
      createdAt
      updatedAt
      noSubscriptionNeeded
      hasValidSubscription
    }
  }
`;

const COLS = [
  {
    accessor: 'name',
    displayString: 'Name',
  },
  {
    accessor: 'noSubscriptionNeeded',
    displayString: 'No Subscription Needed?',
    format: asCheck,
    style: { verticalAlign: 'middle' },
    isSmall: true,
  },
  {
    accessor: 'hasValidSubscription',
    displayString: 'Valid Subscription',
    format: asCheck,
    style: { verticalAlign: 'middle' },
    isSmall: true,
  },
  ...timeColumns,
];

const TeamsTable = () => {
  const { msg, data } = useQueryWithMsg(AdminTeamTableQuery, {
    fetchPolicy: 'cache-and-network',
  });

  const navigate = useNavigate();

  const getItems = (itemData) => {
    const { teams } = itemData;
    return teams.map((team) => ({
      ...team,
      onClick: () => {
        navigate(`${team.id}/members`);
      },
    }));
  };

  return (
    <PaddedItemsTable
      data={data}
      msg={msg}
      cols={COLS}
      getItems={getItems}
      createButton="New Team"
      createButtonOnClick={() => {
        navigate('new');
      }}
      hover
      searchable
      showCount
      search={searchBy(['name'])}
    />
  );
};

export default TeamsTable;
